module.exports = {
  h32: require("./xxhash"),
  h64: require("./xxhash64")
};